import React from 'react';
import { FaArrowAltCircleUp, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const Stickyicon = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <a
                href="tel:+918989447040"
                className="floating-contact-btn floating-call-btn floating-call-btn-left"
                aria-label="Call us"
                title="Call us"
            >
                <FaPhoneAlt />
            </a>

            <div className="sticky-contact-icon" aria-label="Floating contact buttons">
                <a
                    href="https://wa.me/919039303090"
                    target="_blank"
                    rel="noreferrer"
                    className="floating-contact-btn floating-whatsapp-btn"
                    aria-label="WhatsApp us"
                    title="WhatsApp us"
                >
                    <FaWhatsapp />
                </a>

                <button
                    type="button"
                    className="floating-contact-btn floating-top-btn"
                    aria-label="Back to top"
                    title="Back to top"
                    onClick={scrollToTop}
                >
                    <FaArrowAltCircleUp />
                </button>
            </div>
        </>
    );
};

export default Stickyicon;
